import classNames from "classnames";
import { forwardRef, TdHTMLAttributes } from "react";

export const TableCell = forwardRef<
  HTMLTableCellElement,
  TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>, ref) => (
  <td
    ref={ref}
    className={classNames(
      "g-table__cell g-table__cell_edge-padding",
      className,
    )}
    {...props}
  />
));
TableCell.displayName = "TableCell";
